import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radio", "followUp"];

  connect() {
    this.refresh();
  }

  change() {
    this.refresh();
  }

  refresh() {
    const checked = this.radioTargets.find(r => r.checked);

    this.followUpTargets.forEach(wrapper => {
      const show = checked && wrapper.dataset.radioOtherIndex === checked.value;
      wrapper.style.display = show ? "" : "none";

      if (!show) {
        wrapper.querySelectorAll("input, select, textarea").forEach(el => {
          el.value = "";
        });
      }
    });
  }
}
